import React from 'react';
import { style } from 'typestyle';
import Icon from 'mdi-react/ExclamationIcon';
import * as styles from './cards.styles';
import { CrossAxisAlignment, MainAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly text: string;
  readonly onClick?: () => void;
}

const DashboardActionCard = ({ text, onClick }: Props): React.JSX.Element => (
  <Row
    className={style(styles.actionCard(onClick !== undefined))}
    key={text}
    onClick={onClick}
    crossAxisAlignment={CrossAxisAlignment.Center}
    mainAxisAlignment={MainAxisAlignment.Stretch}
  >
    <Icon className={style(styles.actionIcon(true))} />
    <span className={style(styles.actionBody)}>{text}</span>
  </Row>
);

export default DashboardActionCard;
